import React from "react";
import { COMPANY } from "./companyData";

const CopyButton = ({ value }) => (
  <button
    onClick={() => navigator.clipboard.writeText(value)}
    className="
      <button w-24 px-2 py-1
      text-[10px]
      rounded-lg
      bg-cyan-500/20
      border border-cyan-500/30
      hover:bg-cyan-500/30
    "
  >
    📋 Copy
  </button>
);

export default function CompanyInfo() {
  return (
    <div
      className="
        rounded-3xl
        border border-cyan-500/30
        bg-gradient-to-br
        from-slate-900
        via-cyan-950/30
        to-purple-950/30
        p-5
      "
    >
      <div className="flex items-center gap-2 flex-wrap">
        <h2 className="font-bold text-lg text-cyan-300">
          {COMPANY.companyName}
        </h2>

        <span
          className="
            px-2 py-1
            rounded-full
            text-[10px]
            bg-green-500/20
            text-green-300
            border border-green-500/30
          "
        >
          ✅ VERIFIED COMPANY ACCOUNT
        </span>
      </div>

      <div className="text-xs text-gray-400 mt-1">
        Official Think5Whys Entity Information
      </div>

      <div className="grid md:grid-cols-2 gap-3 mt-4">

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            Email
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.email}
            </span>

            <CopyButton value={COMPANY.email} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            WhatsApp
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white">
              {COMPANY.whatsapp}
            </span>

            <CopyButton value={COMPANY.whatsapp} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            CIN
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.cin}
            </span>

            <CopyButton value={COMPANY.cin} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            PAN
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.pan}
            </span>

            <CopyButton value={COMPANY.pan} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            TAN
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.tan}
            </span>

            <CopyButton value={COMPANY.tan} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            GST
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.gst}
            </span>

            <CopyButton value={COMPANY.gst} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            DPIIT (Startup India) Recognition 
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.dpiit}
            </span>

            <CopyButton value={COMPANY.dpiit} />
          </div>
        </div>

        <div className="rounded-xl bg-black/20 p-3">
          <div className="text-[10px] text-gray-400 uppercase">
            Udyam Registration
          </div>

          <div className="flex justify-between gap-2 mt-1">
            <span className="text-white break-all">
              {COMPANY.udyam}
            </span>

            <CopyButton value={COMPANY.udyam} />
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-xl bg-black/20 p-4">
        <div className="text-[10px] text-gray-400 uppercase">
          Registered Office
        </div>

        <div className="text-white mt-1">
          {COMPANY.address}
        </div>
      </div>
    </div>
  );
}